// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"180":"video","303":"widget","495":"feed"}[chunkId] + "." + {"180":"3b8e11608389af161e4f","303":"ee21db348f5d48b6a10d","495":"88c5bcffdbbc44396cb6"}[chunkId] + ".js";
};